import Operation from './Operation';

export default function SafetyMove(props) {
  return (<Operation {...props}>
  SafetyMove
  </Operation>);
};
